import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { chatGenerateToolChoices, type ChatGenerateToolChoice } from '@src/components/sco/Chat/chatGenerate';
import { CHAT_GENERATE_TOOLS } from '@src/gql/queries/ChatGenerateTools';
import { useMemo } from 'react';
const PAGE_SIZE = 200;

/**
 * Chat tools for the Generate picker. One page, title order. `excludeToolId` is this account's
 * reply tool, which already runs as "This reply".
 */
export function useChatGenerateTools(enabled, excludeToolId) {
  const $ = _c(8);
  const t0 = !enabled;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      order: [["title", "ASC"]],
      pageSize: PAGE_SIZE
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t0) {
    t2 = {
      skip: t0,
      variables: t1
    };
    $[1] = t0;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const query = useQuery(CHAT_GENERATE_TOOLS, t2);
  const t3 = query.data?.scoTools?.items;
  let t4;
  if ($[3] !== excludeToolId || $[4] !== t3) {
    t4 = chatGenerateToolChoices(t3, excludeToolId);
    $[3] = excludeToolId;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const tools = t4;
  let t5;
  if ($[6] !== tools) {
    t5 = {
      tools
    };
    $[6] = tools;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}